var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.file.id
    ? _c(
        "v-card",
        _vm._g(
          {
            class: { pointer: _vm.pickerMode },
            attrs: { "max-width": "330px", flat: "" },
          },
          _vm.pickerMode
            ? { click: () => _vm.toggleFileHandler(_vm.file.id) }
            : {}
        ),
        [
          _c(
            "v-card-text",
            { staticClass: "pa-0" },
            [
              _c(`MediaPreview${_vm.file.type}`, {
                tag: "component",
                attrs: {
                  file: _vm.file,
                  "is-chosen": _vm.isChosen,
                  "picker-mode": _vm.pickerMode,
                  "hide-delete": _vm.hideDelete,
                },
                on: {
                  "choose-file": _vm.previewFileHandler,
                  "remove-file": _vm.removeFile,
                },
                scopedSlots: _vm._u(
                  [
                    _vm.pickerMode
                      ? {
                          key: "body",
                          fn: function () {
                            return [
                              _c("v-card-subtitle", { staticClass: "pb-0" }, [
                                _vm._v(" " + _vm._s(_vm.file.type) + " "),
                              ]),
                              _c(
                                "v-card-text",
                                { staticClass: "text--primary" },
                                [_vm._v(" " + _vm._s(_vm.file.fileName) + " ")]
                              ),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
          _vm.isImagePreviewOpen
            ? _c("PreviewDialog", {
                ref: "previewDialog",
                attrs: { file: _vm.file, caption: _vm.caption },
                on: {
                  close: function ($event) {
                    _vm.isImagePreviewOpen = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }